const RECOMMENDED_MEDIA_DROPDOWN_TYPES = {
    ALL: 'ALL',
    VIDEOS: 'VIDEOS',
    IMAGES: 'IMAGES',
};

export default RECOMMENDED_MEDIA_DROPDOWN_TYPES;
